// Die Tableiste am unteren Rand.
//
// Vier Punkte plus „Mehr". Welche vier, hängt an der Rolle — ein Mitarbeiter
// braucht Lager und Kasse, ein Inhaber seine Mandanten. Die Belegung kommt
// aus lib/navigation.ts und ist dort geprüft.
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../gemeinsam/lib/AuthContext';
import { useSprache } from '../gemeinsam/lib/i18n';
import { useBenachrichtigungen } from '../bereiche/aufgaben/lib/benachrichtigungen';
import { tableiste } from '../gemeinsam/lib/navigation';
import type { Rolle } from '../gemeinsam/lib/navigation';
import Icon from '../gemeinsam/komponenten/Icon';
import { tippen } from './haptik';

export function rolleVon(istOwner: boolean, istAdmin: boolean): Rolle {
  return istOwner ? 'inhaber' : istAdmin ? 'admin' : 'mitarbeiter';
}

export default function Tableiste() {
  const { flags, istOwner, istAdmin } = useAuth();
  const { t } = useSprache();
  const { anzahlChat, anzahlSonstige } = useBenachrichtigungen();
  const ort = useLocation();
  const navigate = useNavigate();

  const punkte = tableiste(rolleVon(istOwner, istAdmin), flags);

  const zahlFuer = (pfad: string) =>
    pfad === '/aufgaben' ? anzahlSonstige : pfad === '/chat' ? anzahlChat : 0;

  function hin(pfad: string, aktiv: boolean) {
    if (aktiv) {
      // Zweiter Tipp auf denselben Punkt: nach oben, nicht noch einmal
      // dorthin navigieren. So macht es jede App, und es erspart einen
      // überflüssigen Verlaufseintrag.
      document.getElementById('app-buehne')
        ?.querySelector('[data-rumpf]')
        ?.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    void tippen('auswahl');
    // Ersetzen, nicht schieben: ein Tableistenwechsel ist kein Schritt in die
    // Tiefe, sondern ein Wechsel der Wurzel.
    navigate(pfad, { replace: true });
  }

  const eintrag = (pfad: string, beschriftung: string, symbol: Parameters<typeof Icon>[0]['name']) => {
    const aktiv = pfad === '/' ? ort.pathname === '/' : ort.pathname.startsWith(pfad);
    const zahl = zahlFuer(pfad);
    return (
      <button
        key={pfad}
        onClick={() => hin(pfad, aktiv)}
        aria-current={aktiv ? 'page' : undefined}
        className={`relative flex flex-1 flex-col items-center justify-center gap-0.5 pt-1.5 ${
          aktiv ? 'text-marke-600 dark:text-marke-400' : 'text-slate-400 dark:text-slate-500'}`}
      >
        {zahl > 0 && (
          <span className="absolute end-[calc(50%-20px)] top-1 grid h-[17px] min-w-[17px] place-items-center rounded-full bg-rose-500 px-1.5 text-[10.5px] font-bold text-white">
            {zahl > 99 ? '99+' : zahl}
          </span>
        )}
        <Icon name={symbol} groesse={23} />
        <span className="text-[10.5px] font-medium">{beschriftung}</span>
      </button>
    );
  };

  return (
    <nav
      style={{
        height: 'calc(var(--leiste-h) + var(--sicher-unten))',
        paddingBottom: 'var(--sicher-unten)',
      }}
      aria-label={t('allg.menue')}
      className="z-40 flex shrink-0 items-stretch border-t border-slate-200/70 bg-white/85 backdrop-blur-xl dark:border-slate-800/70 dark:bg-slate-900/85"
    >
      {punkte.map(p => eintrag(p.pfad, t(p.schluessel), p.symbol))}
      {eintrag('/mehr', t('nav.mehr'), 'menue')}
    </nav>
  );
}
